import React from 'react'
import CreateAuthorWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import AuthorForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './create.styles.scss'

class CreateAuthor extends React.Component {

    constructor(props) {
        super(props)
        this.createAuthorWorker = CreateAuthorWorker(this)
        this.state = this.createAuthorWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createAuthorWorker.isValid() && this.createAuthorWorker.createAuthor()
    }

    onCancel = () => this.props.history.push('/author/authors')

    render() {
        return (
            <div className="create-author">
                <div className="card">
                    <Link className="btn" to="/author/authors">Authors</Link>
                    <div className="header">
                        <h4>Create Author</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <AuthorForm {...this.state} action="Add Author" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateAuthor)